/*
 * Entra (Azure AD) sign-in config for the admin portal.
 *
 * Set ADMIN_CLIENT_ID to the client id of the Entra app registration you create
 * for the admin SPA (see DEPLOYMENT.md "Admin portal auth"). The app reg must:
 *   - have a SPA redirect URI of  https://<SWA_HOST>/admin.html  (and https://localhost:3000/admin.html for dev)
 *   - expose an API scope  api://<ADMIN_CLIENT_ID>/access_as_user
 *
 * Auth is enforced only when served from a non-localhost host, so local dev
 * (npm run dev-server) keeps working without sign-in. The backend independently
 * enforces it via ADMIN_AUTH_ENABLED, so a real user can't bypass it.
 */

/* global location */

export const TENANT_ID = "c4a8639a-d5a9-4b9a-aa77-c15cb9c9b6b2";
export const ADMIN_CLIENT_ID = "0848b88b-41a7-4ffb-a94a-ab69e347eaf2";
export const API_SCOPE = `api://${ADMIN_CLIENT_ID}/access_as_user`;

const isLocalhost =
  typeof location !== "undefined" && /^(localhost|127\.0\.0\.1)$/i.test(location.hostname);

// Enabled in production (non-localhost) once a real client id is configured.
export const AUTH_ENABLED = !isLocalhost && !ADMIN_CLIENT_ID.startsWith("REPLACE");
